import {VARIANT} from "../../../constants";
import Button from "../../Common/Button";
import React from "react";
import {clsx} from "clsx";
import {isMobile} from "react-device-detect";
import {text} from "../../../constants/text";

const ActionButtons = ({onClose, onConfirm}) => (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Button className='w-full' variant={VARIANT.PRIMARY} onClick={onConfirm}>
            {text.confirm}
        </Button>
        <Button className={
            clsx(isMobile ? 'w-fit mx-auto text-[#197D55] bg-transparent underline transition-all duration-300 !p-4' : 'w-full border-[#CCCBCB]')}
                variant={VARIANT.SECONDARY}
                onClick={onClose}>
            {text.canceled}
        </Button>
    </div>
);
export default ActionButtons;